"use client";

import { FC, memo, useContext } from "react";
import classNames from "classnames";
import { IMainOddsState } from "@finbackoffice/site-core";
import { IMarketOutcomeFeedResponse } from "@finbackoffice/clientbff-client";
import { MarketStatus } from "@finbackoffice/enums";
import { BetSlipSelectionContext } from "contexts";
import Outcome from "../outcome/Outcome";
import styles from "./main-market.module.sass";

interface IMainMarketProps {
    mainOdds?: IMainOddsState;
    columnCount: number;
    marketStatus?: MarketStatus;
    onOutcomeClick: (outcome: IMarketOutcomeFeedResponse) => void;
    wrapperClassname?: string;
}

const MainMarket: FC<IMainMarketProps> = ({
    mainOdds,
    columnCount,
    marketStatus,
    onOutcomeClick,
    wrapperClassname,
}) => {
    const { isOutcomeSelected } = useContext(BetSlipSelectionContext);

    if (!mainOdds) return null;

    return (
        <div
            className={classNames(
                styles.mainMarket,
                styles[`marketColumn-${columnCount}`],
                wrapperClassname,
            )}>
            <div>
                <Outcome
                    outcome={mainOdds.homeOutcome}
                    marketStatus={marketStatus}
                    variant="mainMarket"
                    active={isOutcomeSelected(mainOdds.homeOutcome?.id ?? 0)}
                    onOutcomeClick={onOutcomeClick}
                />
                {columnCount === 3 && (
                    <Outcome
                        outcome={mainOdds.drawOutcome}
                        marketStatus={marketStatus}
                        variant="mainMarket"
                        active={isOutcomeSelected(mainOdds.drawOutcome?.id ?? 0)}
                        onOutcomeClick={onOutcomeClick}
                    />
                )}
                <Outcome
                    outcome={mainOdds.awayOutcome}
                    marketStatus={marketStatus}
                    variant="mainMarket"
                    active={isOutcomeSelected(mainOdds.awayOutcome?.id ?? 0)}
                    onOutcomeClick={onOutcomeClick}
                />
            </div>
        </div>
    );
};

export default memo(MainMarket);
